<template>
    <div class="container">
        <div class="row h-100 confirm">
            <div class="col-12 col-lg-10 mx-auto  bg-white shadow-sm">
                <div class="row">
                    <div class="col-12 col-lg-6 mx-auto text-center">
                        <div class="border rounded-circle p-3 mx-auto envelope d-flex justify-content-center align-items-center">
                            <img src="../../assets/images/envelope.svg" class="mx-auto my-auto" alt=" envelope">
                        </div>
                        <h2 class="mt-4">Verify your email</h2>
                        <hr class=" m-0 mt-4">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-8 mx-auto text-center">
                        <p class=" m-0 mt-4">We have emailed a message to <b>{{ $store.getters['auth/email'] }}</b>, containing a verification link.
                            Please check your email and follow the instructions contained in the message. </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-6 mx-auto text-center">
                        <hr class=" m-0 mt-4">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-8 mx-auto text-center">
                        <p class=" m-0 mt-5">If you did not receive the email, <button type="button" class="btn btn-link p-0" @click="resend">click here</button> and
                            we’ll send a new one.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '../../utils/api';

export default {
        name: "RegisterDone",
        methods: {
            resend: function () {
                let that = this;
                api.resendVerification().then(() => {
                    that.$toast.success("Verification email successfully sent!");
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/base";

    .confirm {
        min-height: calc(100vh - 145px);
    }

    .envelope {
        border-color: $gray-800 !important;
        width: 90px;
        height: 90px;
        margin-top: 3.375rem;

        img {
            width: 44px;
            height: 33px;
        }
    }
</style>
